import { render, staticRenderFns } from "./FishCounter.vue?vue&type=template&id=35316378&scoped=true"
import script from "./FishCounter.vue?vue&type=script&lang=ts"
export * from "./FishCounter.vue?vue&type=script&lang=ts"
import style0 from "./FishCounter.vue?vue&type=style&index=0&id=35316378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35316378",
  null
  
)

export default component.exports